module.exports = "<div>TEST RETURN</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/test-services/test-return-url.component.html
// module id = 937
// module chunks = 3